import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import SingleBlog from "./SingleBlog.jsx";
import * as s from "./index.module.scss";
import secondaryFont from "@/utils/secondaryFont";
import Link from "next/link.js";

const AllBlogs = ({ dataBlog }) => {
  const [activeFilter, setActiveFilter] = useState("All");
  const [blogs, setBlogs] = useState([]);

  const filters = dataBlog?.blog?.map((item) => item.categoryTitle);
  const filtersArray = Array.from(new Set(filters));
  filtersArray.unshift("All");

  useEffect(() => {
    if (activeFilter === "All") return setBlogs(dataBlog?.blog);
    setBlogs(() => {
      return dataBlog?.blog.filter(({ categoryTitle }) => {
        return categoryTitle === activeFilter;
      });
    });
  }, [activeFilter]);

  return (
    <section className={`section-center ${s.blogs}`}>
      <Container>
        <Row className="flex-xxl-row-reverse justify-content-between">
          <Col xs={12} xxl={2}>
            <div className={s.categories_wrapper}>
              <h3>Categories</h3>
              <div className={`${secondaryFont} ${s.categories}`}>
                {filtersArray?.map((name, idx) => {
                  return (
                    <button
                      className={activeFilter === name ? s.active : ""}
                      key={idx}
                      onClick={() => {
                        setActiveFilter(name);
                      }}
                    >
                      {name}
                    </button>
                  );
                })}
              </div>
            </div>
          </Col>
          <Col xs={12} xxl={9}>
            <div>
              {blogs?.map(
                (
                  { image, title, categoryTitle, date, text, buttonLink },
                  idx,
                ) => {
                  return (
                    <Link href={`/blogs/${buttonLink}`} key={idx}>
                      <SingleBlog
                        image={image.url}
                        title={title}
                        categoryTitle={categoryTitle}
                        date={date}
                        text={text}
                        buttonLabel={"View More"}
                        // buttonLink={buttonLink}
                        textRich={true}
                        key={idx}
                      />
                    </Link>
                  );
                },
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default AllBlogs;
